import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VInput } from 'vuetify/lib/components/VInput';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VStepper, {
    attrs: {
      "vertical": ""
    },
    model: {
      value: _vm.stepperIndex,
      callback: function ($$v) {
        _vm.stepperIndex = $$v;
      },
      expression: "stepperIndex"
    }
  }, [_c(VStepperStep, {
    attrs: {
      "step": "1",
      "color": _vm.color,
      "complete": _vm.stepperIndex > 1
    },
    on: {
      "click": function ($event) {
        _vm.stepperIndex = 1;
        _vm.selectedScope = {};
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('accMgmt.user.scopeSelection')) + "\n    ")]), _c(VStepperContent, {
    attrs: {
      "step": "1"
    }
  }, [_c(VCard, [_vm.stepperIndex === 1 ? _c('core-tenant-scope-tree', {
    attrs: {
      "activeScopeId": _vm.selectedScope.id,
      "subject": _vm.subject,
      "action": _vm.action
    },
    on: {
      "update": _vm.didSelectScope
    }
  }) : _vm._e(), _c(VInput, {
    attrs: {
      "value": !_vm.isNullOrEmpty(_vm.selectedScope.id),
      "rules": [v => v === true]
    }
  })], 1)], 1), _c(VStepperStep, {
    attrs: {
      "step": "2",
      "color": _vm.color,
      "complete": _vm.stepperIndex > 2
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('accMgmt.user.roleSelection')) + "\n    ")]), _c(VStepperContent, {
    attrs: {
      "step": "2"
    }
  }, [_vm.selectedScope.id ? _c(VCard, [_c(VCardTitle, [_c('h4', [_vm._v("\n            " + _vm._s(_vm.selectedScope.name) + "\n            "), _vm.selectedScope.tenantName ? _c('span', {
    staticClass: "text-caption"
  }, [_vm._v("\n              (" + _vm._s(_vm.$i18n_t('Common.tenant')) + ": " + _vm._s(_vm.selectedScope.tenantName) + ")\n            ")]) : _vm._e()])]), _c(VCardText, [_c('core-tenant-role-list', {
    attrs: {
      "isLoading": _vm.isLoading,
      "roles": _vm.roles,
      "scopeId": _vm.selectedScope.id,
      "tenantId": _vm.selectedScope.tenant,
      "userId": _vm.userId,
      "load-roles-internally": ""
    },
    on: {
      "rolesChosen": _vm.rolesChosen
    }
  }), _c(VInput, {
    attrs: {
      "value": _vm.allowEmptyRoleSet === true || _vm.chosenRoles.length > 0,
      "rules": [v => v === true]
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };